import { render } from "./SharedByButton.vue?vue&type=template&id=7e09909e"
import script from "./SharedByButton.vue?vue&type=script&lang=js"
export * from "./SharedByButton.vue?vue&type=script&lang=js"
script.render = render

export default script